import { useSearchParams } from 'react-router-dom';
import { TasksPage } from './TasksPage.js';
import { TaskBoardPage } from './TaskBoardPage.js';
import { TimelinePage } from '../timeline/TimelinePage.js';

const VIEWS = [
  { id: 'list', label: 'List' },
  { id: 'board', label: 'Board' },
  { id: 'timeline', label: 'Timeline' },
] as const;
type ViewId = (typeof VIEWS)[number]['id'];

/** Single home for the three ways of looking at a project's tasks. */
export function TasksHubPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('view');
  const view: ViewId = VIEWS.some((v) => v.id === raw) ? (raw as ViewId) : 'list';

  return (
    <div className="flex h-full flex-col">
      <div className="flex px-4 pt-4 sm:px-6">
        <div
          role="tablist"
          className="inline-flex gap-0.5 rounded-lg border border-border bg-surface-2 p-0.5"
        >
          {VIEWS.map((v) => (
            <button
              key={v.id}
              role="tab"
              aria-selected={view === v.id}
              onClick={() => setParams(v.id === 'list' ? {} : { view: v.id }, { replace: true })}
              className={`rounded-md px-3 py-2 text-xs font-medium md:py-1 ${
                view === v.id ? 'bg-surface text-text shadow-sm' : 'text-muted hover:text-text'
              }`}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
      <div className="min-h-0 flex-1">
        {view === 'board' ? (
          <TaskBoardPage />
        ) : view === 'timeline' ? (
          <TimelinePage />
        ) : (
          <TasksPage />
        )}
      </div>
    </div>
  );
}
